import { PageType } from "@constants/pageTypes";

export const getLoginUrl = (redirectUrl: string) => {
  if (!redirectUrl) return "";
  const utmParamsString: string = "";
  // Hostname
 const HOSTNAME = `${process.env.NEXT_PUBLIC_FRONTEND_HOST}`;
 const AUTH_REDIRECT_URL = `${HOSTNAME}/auth/`;

 const USER_IDENTITY_CONFIG = {
    ACKO_HOSTNAME: process.env.NEXT_PUBLIC_ACKO_HOST,
    CLIENT_ID: process.env.NEXT_PUBLIC_AD_CLIENT_ID,
    RESPONSE_TYPE: "code",
    IDENTITY_TYPE: "d2c",
    SCOPE: "offline_access",
    REALM: process.env.NEXT_PUBLIC_AD_REALM,
    };
  const state = {
    redirectUrl: `${redirectUrl}`,
  };
  const stateString = JSON.stringify(state);

  let loginUrl = `${USER_IDENTITY_CONFIG.ACKO_HOSTNAME}/v1/signin?client_id=${
    USER_IDENTITY_CONFIG.CLIENT_ID
  }&redirect_uri=${AUTH_REDIRECT_URL}&state=${encodeURIComponent(
    stateString
  )}&response_type=${USER_IDENTITY_CONFIG.RESPONSE_TYPE}&identity_type=${
    USER_IDENTITY_CONFIG.IDENTITY_TYPE
  }&scope=${USER_IDENTITY_CONFIG.SCOPE}&realm=${
    USER_IDENTITY_CONFIG.REALM
  }`;

  if (!!utmParamsString) {
    loginUrl += `&${utmParamsString}`;
  }
  return loginUrl;
};

// Helper function to conditionally add captureIntent parameter to URL
export const addCaptureIntentIfNeeded = (
  url: string,
  mmvDetails?: any,
  loginType?: string,
  pageType?: PageType,
  flowType?: string,
): string => {
  if (typeof window === "undefined") return url;

  try {
    const buyingIntent = sessionStorage.getItem("buying_intent");
    if (buyingIntent !== "false") {
      sessionStorage.setItem("mmvDetails", JSON.stringify(mmvDetails));
      if (!!pageType)
        sessionStorage.setItem("pageType", JSON.stringify(pageType));
      if (!!loginType)
        sessionStorage.setItem("loginType", loginType);
      if (!!flowType)
        sessionStorage.setItem("flowType", flowType);
      const urlObj = new URL(url);
      urlObj.searchParams.set("captureIntent", "true");
      return urlObj.toString();
    }
  } catch (error) {
    console.warn("Failed to access sessionStorage:", error);
  }

  return url;
};
